module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/articles/feed/news/view/news-view.component.css
// module id = ./src/app/articles/feed/news/view/news-view.component.css
// module chunks = main